var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M78.8,20.4c-0.2-0.2-0.4-0.3-0.7-0.3H21.1c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v57.1 c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h57.1c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7V21.1 C79.1,20.8,79,20.6,78.8,20.4z M22.1,22.1h55.1l0,55.1H22.1L22.1,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M36.7,61.5h-9.2c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v9.2c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 h9.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7C37.2,61.6,37,61.5,36.7,61.5z M28.5,63.5h7.2 l0,7.2h-7.2L28.5,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M70.6,61.5H43c-0.3,0-0.5,0.1-0.7,0.3S42,62.2,42,62.5v9.2c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 h27.5c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7C71.1,61.6,70.8,61.5,70.6,61.5z M44,63.5h25.5 l0,7.2H44L44,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M27.5,38.4h9.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.4-0.3-0.7-0.3h-9.2c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v9.2c0,0.3,0.1,0.5,0.3,0.7C27,38.3,27.3,38.4,27.5,38.4z  M35.7,29.2l0,7.2h-7.2l0-7.2H35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M70.6,27.2H43c-0.3,0-0.5,0.1-0.7,0.3S42,27.9,42,28.2v9.2c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 h27.5c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7C71.1,27.3,70.8,27.2,70.6,27.2z M44,29.2h25.5 l0,7.2H44L44,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M70.6,44.3h-9.2c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v9.2c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3 h9.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7C71.1,44.4,70.8,44.3,70.6,44.3z M62.4,53.5l0-7.2 h7.2l0,7.2H62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcac04",
    d: "M27.5,55.5h27.5c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-9.2c0-0.3-0.1-0.5-0.3-0.7 c-0.2-0.2-0.4-0.3-0.7-0.3H27.5c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7v9.2c0,0.3,0.1,0.5,0.3,0.7C27,55.4,27.3,55.5,27.5,55.5z  M54.1,53.5H28.5l0-7.2h25.5L54.1,53.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy200);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-200.a662c508da83f093a894e8dce2cfd3fd.svg";
export { ForwardRef as ReactComponent };